// Trạng thái học tuần tự của module, khớp MODULE_GATE_STATUS ở back-end (lesson-access.service.js).
// Đạt bài test khi trên 5/10 điểm (điểm lưu theo thang 100 nên mốc là 51).
export const MODULE_PASS_SCORE = 51;
export const PASS_RULE_TEXT = 'Đạt khi trên 5/10 điểm';

export const GATE = Object.freeze({
  UNDER_CONSTRUCTION: 'UNDER_CONSTRUCTION',
  LOCKED: 'LOCKED',
  OPEN: 'OPEN',
  PASSED: 'PASSED',
});

export function isGateBlocked(gate) {
  return gate?.status === GATE.LOCKED || gate?.status === GATE.UNDER_CONSTRUCTION;
}

export function gateMessage(gate) {
  if (gate?.status === GATE.UNDER_CONSTRUCTION) return 'Module đang trong giai đoạn xây dựng nội dung';
  if (gate?.status === GATE.LOCKED) {
    const code = gate.blockedBy?.code;
    return `Làm đạt bài test ${code ? `module ${code}` : 'module trước'} (trên 5/10 điểm) để mở`;
  }
  return '';
}

// Điểm thang 100 -> chuỗi thang 10, ví dụ 80 -> "8"
export function toTenScale(score) {
  if (score === null || score === undefined) return '';
  return String(Math.round(score) / 10).replace('.', ',');
}
